export const comments_5618947 = {"data":{"data":[],"links":{}}}